// Stationed ships of the viewer's own systems for the close zoom tier (spec 15c §3.4, P30): only
// own fleets parked in own systems; allied reinforcements and members' systems are not shown.
import type { OwnFleet, ShipCounts, ShipType } from '@stars-and-ships/api-types';

export function stationedShips(
  fleets: readonly OwnFleet[],
  ownSystemIds: ReadonlySet<string>
): Map<string, ShipCounts> {
  const out = new Map<string, Partial<Record<ShipType, number>>>();
  for (const fleet of fleets) {
    const at = fleet.locationSystemId;
    if (fleet.status !== 'stationed' || !at || !ownSystemIds.has(at)) continue;
    const counts = out.get(at) ?? {};
    for (const group of [fleet.ships, fleet.stealthShips]) {
      for (const [type, n] of Object.entries(group) as [ShipType, number][]) {
        if (n > 0) counts[type] = (counts[type] ?? 0) + n;
      }
    }
    if (Object.keys(counts).length > 0) out.set(at, counts);
  }
  return out;
}

const short = (value: number) => (value < 10 ? Math.floor(value * 10) / 10 : Math.floor(value));

/** "7", "999", "1.2k", "12k", "1.5M". */
export function formatShipCount(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${short(n / 1000)}k`;
  return `${short(n / 1_000_000)}M`;
}
